import React from 'react';
import { Card, Typography } from 'antd';
import { UserAddOutlined } from '@ant-design/icons';
import EnquiryForm from './EnquiryForm';
import { useClientConfig } from '../../common/client/ClientConfigProvider';
import { DEFAULT_SIGNUP_GUEST_TYPES } from '../../model/client/ClientSettings';

const { Title, Paragraph } = Typography;

// Guest signup is the lightweight walk-in capture: name, contact, interests and
// a per-client guest type. Tours (with the pricing sheet + QR sign-up) now live
// on the dedicated /tour-signup screen.
const GuestSignupForm: React.FC = () => {
    const { signup } = useClientConfig();
    const guestTypeOptions = signup?.guestTypes ?? DEFAULT_SIGNUP_GUEST_TYPES;
    return (
        <div style={{ maxWidth: 720, margin: '0 auto' }}>
            <Card>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16, gap: 8 }}>
                    <UserAddOutlined style={{ fontSize: 24 }} />
                    <Title level={3} style={{ margin: 0 }}>
                        Guest Signup
                    </Title>
                </div>
                <Paragraph type="secondary">
                    Capture basic details for guests and record their interests so you can follow up later.
                </Paragraph>

                <EnquiryForm
                    guestTypeOptions={guestTypeOptions}
                    submitLabel="Create Guest"
                    redirectOnSuccess="/home"
                    testIdPrefix="guest-signup"
                />
            </Card>
        </div>
    );
};

export default GuestSignupForm;
